// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import common from './js/common'

import {Axios} from '@/api/Axios';
// import $ from 'jquery'
// import {openPopAlert, closePopAlert} from '@/js/commonJQuery'
import VueDaumPost from 'vue-daum-postcode'
import {LoginConfig} from '@/store/Constraints';

import $ from "expose-loader?exposes[]=$&exposes[]=jQuery!jquery";
import {showMenu,hideMenu, openPop,closePop,openPopAlert, closePopAlert,expandMemBar,downsizeMemBar} from '@/js/commonJQuery'
// import {showMenu,hideMenu,showDimmed, hideDimmed,openPop,closePop, openPopAlert, closePopAlert,expandMemBar,downsizeMemBar} from '@/js/commonJQuery'
// require('expose?$!expose?jQuery!jquery')
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import "vue-scroll-picker/dist/style.css"

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'


import VueMask from 'v-mask'
import VModal from 'vue-js-modal'

import CommonHeader from '@/components/common/CommonHeader.vue';
import PopCommonAlert from '@/components/common/PopCommonAlert.vue';
import PopCommonConfirm from '@/components/common/PopCommonConfirm.vue';

import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
 
Vue.use(VueToast);

Vue.config.productionTip = false

Vue.use(VModal, {
  dynamicDefaults: {
    
    adaptive : true,
    scrollable : true,
    height: 'auto'
  }
})

Vue.use(VueMask);

Vue.use(common);
Vue.use(Loading);
Vue.use(VueMoment, {
  moment,
})

// Vue.filter('toCurrency', function (value) {
//   if (typeof value !== "number") {
//       return value;
//   }
//   var formatter = new Intl.NumberFormat('ko-KR', {
//       style: 'toCurrency',
//       currency: 'KRW',
//       minimumFractionDigits: 0
//   });
//   return formatter.format(value);
// });

router.beforeEach((to, from,next) =>{
  
  // console.log(`main.beforeach loginState`,this.loginState)
  if(to)console.log(`main.beforeach to`,to)
  if(from)console.log(`main.beforeach from`,from)
  
  //메인이 아닌 다른 주소로 들어온 경우 로그인 상태가 false인 경우 홈으로 강제로 보내버림.
  // if(to.path != "/" && to.path != '/login' && !to.path.startsWith('/member')){

    // if(to.path.startsWith('/order' || '/giftshop' || '/stamp' || '/findShop' || '/coupon' || '/card' || '/cart' || '/gift' || '/cart')){
    //   if(this.loginState != true){


    //     // this.showAlertMessage('로그인 후 이용할 수 있습니다.')
    //     if(window.confirm('로그인 후 이용할 수 있습니다.')){
    //       next('/')
    //     }
    //     return;
    //   }
    // }
  

  next();
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-KR', {
      // style: 'currency',
      // currency: 'KRW',
      minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('toPhone', function (phoneNumber) {

  if (!phoneNumber) return phoneNumber;
  phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

  let tmp = '';
  if (phoneNumber.length < 4) {
    tmp = phoneNumber;
  } else if (phoneNumber.length < 7) {
    tmp = phoneNumber.replace(/(\d{3})(\d{3})/, "$1-$2");
  } else if (phoneNumber.length == 8) {
    tmp = phoneNumber.replace(/(\d{4})(\d{4})/, "$1-$2");
  } else if (phoneNumber.length < 10) {
    if (phoneNumber.substr(0, 2) == '02') { //02-123-5678
      tmp = phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
    } else {
      tmp = phoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3");
    }
  } else if (phoneNumber.length < 11) {
    if (phoneNumber.substr(0, 2) == '02') { //02-1234-5678
      tmp = phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
    } else { //010-123-4567
      tmp = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }
  } else { //010-1234-5678
    tmp = phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }
  return tmp;
});

Vue.filter('toTime', function (time) {
  let tmp = '';
  if (time.length === 4) {
    tmp = time.replace(/(\d{2})(\d{2})/, "$1:$2");
    return tmp;
  }
  return time;
});

Vue.filter('toDate', function (date) {
  let tmp = '';
  if (date.length === 8) {
    tmp = date.replace(/(\d{4})(\d{2})(\d{2})/, "$1.$2.$3");
    return tmp;
  } else if (date.length === 6) {
    tmp = date.replace(/(\d{2})(\d{2})(\d{2})/, "$1.$2.$3");
    return tmp;
  }
  return time;
});

Vue.filter('toCardNum', function (num) {
  let tmp = '';
  if (num.length === 16) {
    tmp = num.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1 $2 $3 $4");
    return tmp;
  }
  return num;
});

Vue.config.errorHandler = function (err, vm, info) {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.log('Custom vue error handler: ', err, vm.name, info);
};
Vue.config.warnHandler = function (err, vm, info) {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.log('Custom vue warn handler: ', err, vm.name, info);
};

// Prevent vue from spamming the console with "helpful" tips
Vue.config.productionTip = false;

Vue.mixin({
  data(){
    return {
      loading:null,
    }
  },
  create(){
    this.axiosInit();
  },
  computed: {
    accessToken: function(){
      return store.getters[LoginConfig.ACCESS_TOKEN]
    },
    loginState: function(){
      return store.getters[LoginConfig.LOGIN_STATE]
      // return true;
    },
    memberInfo:function(){
      // return {name:'test'}
      return store.getters[LoginConfig.MEMBER_DATA]
    },
    mainInfo:function(){
      return store.getters[LoginConfig.MAIN_DATA]
    },
  },
  methods:{
    checkLogin: function(){
      return store.getters[LoginConfig.LOGIN_STATE]
    },
    removeOne(arr) {
      var what, a = arguments, L = a.length, ax;
      while (L > 1 && arr.length) {
          what = a[--L];
          while ((ax= arr.indexOf(what)) !== -1) {
              arr.splice(ax, 1);
          }
      }
      return arr;
    },
    removeAll(arr){
      while (arr.length) { arr.pop(); }
    },
    showMenu:function(){    
      showMenu();
    },

    hideMenu:function(){    
      hideMenu();
    },
    openPop: function(name) {
      openPop(name);
    },
    closePop: function(){
      closePop();
    },
    openPopAlert: function(a){
      openPopAlert(a)
    },
    closePopAlert:function(){
      closePopAlert();
    },
    expandMemBar:function(){
      expandMemBar();
    },
    downsizeMemBar:function(){
      downsizeMemBar();
    },

    // showAlertMessage(msg){
    //   this.alertMessage = msg;
    //   this.openPopAlert('alert-common');
    // },
    showLoading(value){   
      
      // value? this.loading = this.$loading.show():this.loading.hide();
      // console.log(`main.js.methods.showLoading -> value:${value}`,this.loading);
      try {
        if(value){          
            this.loading = this.$loading.show();
            // setTimeout(() => {
            //   console.log(`main.js.methods.showLoading setTimeout -> value:${value}`,this.loading);
              
            //   if(this.loading != null)this.loader.hide()
            // },1000)
        }else{
          
          if(!value && this.loading != undefined) {
            this.loading.hide();            
          }
        }        
      }catch(e){
        console.log(e);
      }
    },
    axiosInit(){
      this.Axios.interceoptors.response.use(
        function(response) {
          return response;
        },
        function(error) {
          if (error.response.status == 401) {
            self.$toaster.error("ERROR: Invalid token detected");
            store.dispatch([LoginConfig.LOGOUT_EVENT],{});
          }
          throw new Error('Invalid token detected')
        }
      );
    }
      
      
      
    // this.Axios.interceptors.response.use(

    // )
  }
})

Vue.component('common-header',CommonHeader)
Vue.component('pop-common-alert',PopCommonAlert)
Vue.component('pop-common-confirm',PopCommonConfirm)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js